// src/components/BackgroundStroke/BackgroundStroke.jsx
import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import styles from './BackgroundStroke.module.scss';

const randomCurve = () => {
  // Offset aleatorio entre -10 y +10
  const startY = 50 + (Math.random() * 20 - 10);
  const endY   = 50 + (Math.random() * 20 - 10);

  // Puntos de control x como antes
  const cp1x = 20 + Math.random() * 20;  
  const cp1y = 30 + Math.random() * 40;  
  const cp2x = 60 + Math.random() * 20;  
  const cp2y = 30 + Math.random() * 40;  

  return `M0,${startY}
          C ${cp1x},${cp1y}
            ${cp2x},${cp2y}
            100,${endY}`;
};

const BackgroundStroke = ({ count = 3 }) => {
  const paths = useMemo(
    () => Array.from({ length: count }, () => randomCurve()),
    [count]
  );

  return (
    <svg
      className={styles.stroke}
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
    >
      {paths.map((d, i) => (
        <motion.path
          key={i}
          d={d}
          fill="none"
          stroke="rgb(172,206,59)"
          strokeWidth={4}
          strokeOpacity={0.1 + i * 0.05}   /* muy baja opacidad: 0.1, 0.15, 0.2 */
          strokeLinecap="round"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{
            duration: 0.5,
            ease: 'easeInOut',
            delay: i * 0.1,
          }}
        />
      ))}
    </svg>
  );
};

export default BackgroundStroke;
